/**
 * @flow
 * @relayHash b5c9fba5229c7aa8d56d5b6ee0874113
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type unarchiveHyeventInput = {|
  clientMutationId?: ?string,
  id: string,
|};
export type unarchiveEventMutationVariables = {|
  input: unarchiveHyeventInput
|};
export type unarchiveEventMutationResponse = {|
  +unarchiveHyevent: ?{|
    +hyevent: ?{|
      +id: string,
      +title: string,
      +maxNoOfGuests: number,
      +additionalGuestAllowed: boolean,
      +maxAdditionalGuests: ?number,
      +ctaText: string,
      +messageTitle: string,
      +message: string,
      +address: string,
      +status: string,
      +propertyId: string,
      +startAt: any,
      +endAt: any,
      +publishAt: ?any,
      +cancelReason: ?string,
      +rsvpedCount: number,
      +image: {|
        +id: string,
        +fileType: string,
        +fileSize: number,
        +fileUrl: string,
        +dimension: ?string,
        +thumbnailUrl: ?string,
      |},
    |}
  |}
|};
export type unarchiveEventMutation = {|
  variables: unarchiveEventMutationVariables,
  response: unarchiveEventMutationResponse,
|};
*/


/*
mutation unarchiveEventMutation(
  $input: unarchiveHyeventInput!
) {
  unarchiveHyevent(input: $input) {
    hyevent {
      id
      title
      maxNoOfGuests
      additionalGuestAllowed
      maxAdditionalGuests
      ctaText
      messageTitle
      message
      address
      status
      propertyId
      startAt
      endAt
      publishAt
      cancelReason
      rsvpedCount
      image {
        id
        fileType
        fileSize
        fileUrl
        dimension
        thumbnailUrl
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "unarchiveHyeventInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "unarchiveHyevent",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "unarchiveHyeventPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "hyevent",
        "storageKey": null,
        "args": null,
        "concreteType": "Hyevent",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "maxNoOfGuests",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "additionalGuestAllowed",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "maxAdditionalGuests",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "ctaText",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "messageTitle",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "message",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "address",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "status",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "propertyId",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "startAt",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "endAt",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "publishAt",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "cancelReason",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "rsvpedCount",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "image",
            "storageKey": null,
            "args": null,
            "concreteType": "Asset",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "fileType",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "fileSize",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "fileUrl",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "dimension",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "thumbnailUrl",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "unarchiveEventMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "unarchiveEventMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "unarchiveEventMutation",
    "id": null,
    "text": "mutation unarchiveEventMutation(\n  $input: unarchiveHyeventInput!\n) {\n  unarchiveHyevent(input: $input) {\n    hyevent {\n      id\n      title\n      maxNoOfGuests\n      additionalGuestAllowed\n      maxAdditionalGuests\n      ctaText\n      messageTitle\n      message\n      address\n      status\n      propertyId\n      startAt\n      endAt\n      publishAt\n      cancelReason\n      rsvpedCount\n      image {\n        id\n        fileType\n        fileSize\n        fileUrl\n        dimension\n        thumbnailUrl\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3ed8c7cf05d686828adfcffbe9eeb758';
module.exports = node;
